// ページ遷移先を判断するためのクラス
export class CloudOperation{
    public returnPage : string = "/";

    // openかsave
    public mode : string = "open";
}